import { ReactComponent as DirectboxReceiveIcon } from 'assets/images/svg/directbox-receive.svg'

import styles from './EmptyDetails.module.scss'

export const EmptyDetails = () => {
  return (
    <div className={styles.container}>
      <div className={styles.icon}>
        <DirectboxReceiveIcon />
      </div>
      <div className={styles.title}>Заявка пока не выбрана</div>
      <div className={styles.description}>
        Нажмите на одну из заявок, чтобы узнать подробности
      </div>
    </div>
  )
}
